import type { User } from '../types';
import {
  NO_VALID_SUBSCRIPTION_MESSAGE,
  SUBSCRIPTION_EXPIRED_MESSAGE,
} from '../constants';

export function hasValidBiddingSubscription(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.plan !== 'PREMIUM' && user.plan !== 'PRO') return false;
  if (user.subscription && user.subscription.active === false) return false;
  return true;
}

export function getLiveBidSubscriptionBlockMessage(
  user: User | null | undefined
): string | null {
  if (hasValidBiddingSubscription(user)) return null;
  if (user?.subscription?.endDate) {
    return SUBSCRIPTION_EXPIRED_MESSAGE;
  }
  return NO_VALID_SUBSCRIPTION_MESSAGE;
}

export function shouldBlockLiveBidEntry(
  bid: { status: string; creatorId: string },
  userId: string | undefined,
  user: User | null | undefined
): boolean {
  if (bid.status !== 'LIVE') return false;
  if (userId && bid.creatorId === userId) return false;
  return getLiveBidSubscriptionBlockMessage(user) != null;
}
